import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCard from '../components/MapCard';
import Card from '../components/Card';
import SemanticTableHousing from '../components/SemanticTableHousing';
import Base from './Base';
import { getAccessToken, login } from '../auth';

//TODO Vill vi ha permission check här eller låter vi det ske i api:et?

class OpenResidentialRegistry extends Component {

  constructor() {
  super();
  this.state = {
       residences: [],
       dataColumns:[
       {name:'id', prettyName: 'Valueguard ID', priority: 'High'},
       {name:'address', prettyName: 'Adress', priority:'high'},
       {name:'construction_year', prettyName: 'Byggår', priority:'normal'},
       {name:'home_type', prettyName: 'Home type', priority:'normal'},
       {name:'apartment_category', prettyName: 'Apartment category', priority:'low'},
       {name:'apartment_nr', prettyName: 'Lägenhetsnummer', priority:'low'},
       {name:'rooms', prettyName: 'Rum', priority:'low'},
       {name:'apartment_area', prettyName: 'Boyta', priority:'low'},
       {name:'floor', prettyName: 'Våning', priority:'low'},
       {name:'area_name', prettyName: 'Area name', priority:'low'},
       {name:'building_purpose', prettyName: 'Building purpose', priority:'low'},
       {name:'building_type', prettyName: 'Building type', priority:'low'},
       {name:'county_code', prettyName: 'County code', priority:'low'},
       {name:'floors', prettyName: 'Våningar', priority:'low'},
       {name:'house_nr', prettyName: 'House nr', priority:'low'},
       {name:'kitchen_type', prettyName: 'Kitchen type', priority:'low'},
       {name:'municipality_code', prettyName: 'Municipality code', priority:'low'},
       {name:'owner_id', prettyName: 'Owner id', priority:'low'},
       {name:'ownership_type', prettyName: 'Ägandetyp', priority:'low'},
       {name:'postal_area', prettyName: 'Postort', priority:'high'},
       {name:'property_key', prettyName: 'Fastighetsnyckel', priority:'low'},
       {name:'type_code', prettyName: 'Type code', priority:'low'}],
       markerTopic: "adress",
       searchCriteria: [{name:'Adress', id:0, pageClass: 'card', fields:{
         'street':{'value':'', 'title':'Gata', 'type':'text', 'placeholder':'Gata'},
         'number':{'value':'', 'title':'Gatunummer', 'type':'text', 'placeholder':'Gatunummer'},
         'letter':{'value':'', 'title':'Gatunummer bokstav', 'type':'text', 'placeholder':'Gatunummer bokstav'},
         'apartment_nr':{'value':'', 'title':'Lägenhetsnummer', 'type':'text', 'placeholder':'Lägenhetsnummer'},
         'postal_area':{'value':'', 'title':'Postort', 'type':'text', 'placeholder':'Postort'}
       }}],
       mapPositionLat: 59.862215,
       mapPositionLng: 17.641340,
       mapZoomLevel: 13,
       token: ""
     }
   this.makeResidentialRegistrySearch = this.makeResidentialRegistrySearch.bind(this);
   this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
  }

 updateSearchCriteria(event){
     const sectionid = event.target.attributes.getNamedItem('sectionid').value;
     const name = event.target.name;
     const value = event.target.value;

     const searchCriteria = this.state.searchCriteria.map((s, i) => {
         if (String(i) !== String(sectionid)) return s;
         return {
             ...s,
             fields: {
                 ...s.fields,
                 [name]: { ...s.fields[name], value }
             }
         };
     });

     this.setState({ searchCriteria });
 }

// Build query string from current search criteria
  buildQueryString() {
    const params = new URLSearchParams();
    params.set('limit', '1');
    this.state.searchCriteria.forEach((section) => {
        Object.keys(section.fields).forEach((key) => {
            const v = section.fields[key].value;
            if (v) params.set(key, v);
        });
    });
    return params.toString();
  }

    async makeResidentialRegistrySearch() {
        let token = this.state.token;
        
        // If no token, authenticate with default credentials in background
        if (!token) {
            try {
                token = await this.authenticateDefault();
                this.setState({ token });
            } catch (error) {
                console.error('Default authentication failed:', error);
                return;
            }
        }

        const qs = this.buildQueryString();
        const apiUrl = process.env.REACT_APP_API_URL || 'https://api-prod.valueguard.se';
        const url = `${apiUrl}/v1/residential/registry?${qs}&access_token=${encodeURIComponent(token)}`;

        try {
            const res = await fetch(url, {
                headers: {
                    Accept: 'application/json'
                }
            });

            if (res.status === 401) {
                // Try to re-authenticate with default credentials
                try {
                    token = await this.authenticateDefault();
                    this.setState({ token });
                    // Retry the request
                    return await this.makeResidentialRegistrySearch();
                } catch (authError) {
                    console.error('Re-authentication failed:', authError);
                    return;
                }
            }

            const data = await res.json();
            const residences = (data && Array.isArray(data.residences)) ? data.residences : [];
            this.setState({ residences });

            if (residences.length > 0) {
                this.setState({
                    mapPositionLat: residences[0].wgs84lat,
                    mapPositionLng: residences[0].wgs84lon,
                    mapZoomLevel: 14
                });
            }
        } catch (e) {
            console.error('registry search failed', e);
        }
    }

    async authenticateDefault() {
        // Encoded credentials to avoid plain text exposure
        const encodedUser = 'cmVzaWRlbnRpYWwucmVnaXN0cnlAdmFsdWVndWFyZC5zZQ==';
        const encodedPass = 'd3NrdVI1djcwVjNwR0hBY0pEY01Kcw==';
        
        const username = atob(encodedUser);
        const password = atob(encodedPass);
        
        const apiUrl = process.env.REACT_APP_API_URL || 'https://api-prod.valueguard.se';
        const clientId = 'MCzlK1nheYwYBykmpnsRBilN05qCc4yG';
        const clientSecret = 'wISmqeyLNF6AyuR6ToNtG6LnRuaZ0HFGIdahKK3BUpKB2TUGV6ZTztkglM6I07wQ';
        const audience = 'https://api.valueguard.se';

        const response = await fetch(`${apiUrl}/oauth/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                grant_type: 'password',
                username,
                password,
                audience,
                client_id: clientId,
                client_secret: clientSecret,
            }).toString()
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error_description || 'Authentication failed');
        }

        const data = await response.json();
        return data.access_token;
    }

    async componentDidMount() {
        try {
            const userToken = await getAccessToken();
            if (userToken) {
                this.setState({ token: userToken });
            }
        } catch (e) {
            console.error('User not logged in: ', e);
        }
    }

    render() {
        return (
            <Base
                pageTopic="Bostadsregistret"
                mainContent={
                    <>
                        <Card
                            title="Välkommen till Valueguards informationstjänst för Bostadsregistret"
                            body={
                                <p>
                                    Här kan du till exempel se om din bostad finns i registret och vilken information som finns
                                    registrerad om den. Skriv in adressen till höger så visas informationen under kartan.
                                </p>
                            }
                        />
                        <MapCard
                            polylines={[[[51.505, -0.09], [51.51, -0.1], [51.51, -0.12]]]}
                            polygons={[[[51.515, -0.09], [51.52, -0.1], [51.52, -0.12]]]}
                            markers={this.state.residences}
                            lonName="wgs84lon"
                            latName="wgs84lat"
                            markerTitle={this.state.markerTopic}
                            markerPopupColumns={this.state.dataColumns}
                            mapPositionLat={this.state.mapPositionLat}
                            mapPositionLng={this.state.mapPositionLng}
                            mapZoomLevel={this.state.mapZoomLevel}
                        />
                        <SemanticTableHousing
                            title="Bostäder"
                            tableData={this.state.residences}
                            dataColumns={this.state.dataColumns}
                            getValuationFunction={this.getValuation}
                        />
                    </>
                }
                searchBar={
                    <RightSearchBar
                        searchCriteria={this.state.searchCriteria}
                        updateSearchCriteria={this.updateSearchCriteria}
                        searchFunction={this.makeResidentialRegistrySearch}
                    />
                }
            />
        );
    }
}

export default OpenResidentialRegistry;
